














import { Vue, Component, Prop } from "vue-property-decorator";
import { DEV_LANGUAGES, getLanguageName, Language } from "@/i18n/Languages";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import { DEFAULT_LOCALE } from "@/plugins/vuetify";
import { selectDevLanguagesAccess } from "@/permissions/UserPermissions";
import { getReactiveActiveUser } from "@/data/repository/UserRepository";

@Component({
  components: {
    picker: PickerDialogComponent,
  },
})
export default class LanguagePickerComponent extends Vue {
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: DEFAULT_LOCALE }) defaultLanguage!: Language;
  @Prop({ default: 'users.language' }) resourcePath!: string;

  selectedLanguage = DEFAULT_LOCALE;
  options = Object.values(Language);

  get activeUser() {
    return getReactiveActiveUser();
  }

  get isAbleToSelectDevLanguages() {
    const activeUser = this.activeUser;

    return selectDevLanguagesAccess(activeUser);
  }

  get filteredOptions() {
    if (this.isAbleToSelectDevLanguages) {
      return this.options;
    }

    return this.options.filter((language) => !DEV_LANGUAGES.includes(language));
  }

  get formatLanguageOptions() {
    return (language: Language) => {
      return getLanguageName(this, language);
    };
  }

  get label() {
    return this.$t(this.resourcePath).toString();
  }

  changeLanguage() {
    this.$emit("changeLanguage", this.selectedLanguage);
  }

  created() {
    this.selectedLanguage = this.defaultLanguage;
  }
}
